import { render } from "./UiSpinner.vue?vue&type=template&id=15270f02"
import script from "./UiSpinner.vue?vue&type=script&lang=js"
export * from "./UiSpinner.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bot-v2/bot-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__